import {FC, ReactElement, lazy, Suspense} from "react";
import { Provider } from "react-redux";
import { CircularProgress } from "@mui/material";
import Landing from "src/screens/Landing";
import store from "src/store";
import Login from "./screens/Login";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./screens/Home/FarmGuardNew/index.css";
import "./screens/SwitchApps.css";
const Home = lazy(() => import("./screens/Home"));
const SwitchApps = lazy(() => import("./screens/SwitchApps"));
// import './App.css';
const App:FC = () : ReactElement => {
  return (
    <Provider store={store} >
    <BrowserRouter >
      <Suspense fallback={
        <div role="status" aria-label="Loading" style={{ minHeight: "100vh", display: "grid", placeItems: "center" }}>
          <CircularProgress size={32} />
        </div>
      }>
      <Routes>
        <Route index element={<Landing />}/>
        <Route path="login" element={<Login />} />
        <Route path="home/*" element={<Home />} />
        <Route path="switchApps" element={<SwitchApps />} />
      </Routes>
      </Suspense>
    </BrowserRouter>
    </Provider>
  );
}

export default App
